import { APIEnvs } from '@smiles/voebiz-core-engine/dist/types';

const defineSmlsEnv = () => {
  const rx = /^(voebiz[-.]|)(.*)\.smiles\.com\.br/g;

  const res = rx.exec(window.location.hostname);

  const smlsEnv = res === null ? 'dev1' : res[2] === 'voebiz' ? 'prd' : res[2];

  if (smlsEnv !== 'prd') {
    window.isDotEnv = window.location.hostname.indexOf('voebiz.') > -1;
  }

  return smlsEnv;
};

export const getEnvFromHost = () => {
  let voebizEnv = window.smlsEnv || defineSmlsEnv();

  if (voebizEnv.includes('uat')) {
    voebizEnv = voebizEnv.replace(/uat/, 'hml');
  }

  const envUppercase = voebizEnv.toLocaleUpperCase();

  const envWindow = window.isDotEnv ? '-N' : '';

  return `${envUppercase}${envWindow}` as APIEnvs;
};
